import React from 'react';

const DividerWidget = ({ config = {} }) => {
  const style = config.style || 'solid';
  const color = config.color || '#E5E7EB';
  const thickness = config.thickness || 1;
  const label = config.label || '';

  return (
    <div className="h-full flex items-center justify-center bg-white px-4">
      {label ? (
        <div className="flex items-center w-full gap-3">
          <div className="flex-1" style={{ borderTop: thickness + 'px ' + style + ' ' + color }} />
          <span className="text-xs font-medium text-gray-400 whitespace-nowrap">{label}</span>
          <div className="flex-1" style={{ borderTop: thickness + 'px ' + style + ' ' + color }} />
        </div>
      ) : (
        <div className="w-full" style={{ borderTop: thickness + 'px ' + style + ' ' + color }} />
      )}
    </div>
  );
};

export default DividerWidget;
